/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/core/shared/setup/polyfills';
import '@/core/setup/env';

import Vue from 'vue';
import router from '@/core/routes.js';
import store from '@/core/store';
import '@/core/setup/api';
import { setStore } from '@/core/restAPI';

import initSentry from '@/core/setup/sentry';
import VueGtm from '@gtm-support/vue2-gtm';
import { localizeApp, i18n } from '@/core/setup/i18n';
import App from './App';

initSentry();
localizeApp(window.sbvrenv.BROWSER_LOCALE);
setStore(store);

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render (h) {
    return h(App);
  },
});

store.subscribe((m, s) => {
  if (m.type === 'setSettings') {
    if (s.public.settings.widget.uaCode) {
      Vue.use(VueGtm, {
        id: s.public.settings.widget.uaCode, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
        queryParams: {
          // Add url query string when load gtm.js with GTM ID (optional)
          // gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
          // gtm_preview: 'env-4',
          // gtm_cookies_win: 'x',
        },
        defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
        compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
        nonce: '2726c7f26d', // Will add `nonce` to the script tag
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: true, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
        trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
      });
    }
  }
});

if (window.sbvrenv.CYPRESS) {
  window.__VUE_DEBUG__ = {
    app,
    router,
    store,
  };
}
